import { Fragment, useState } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset, kuiperClassNames } from '@opallabs/kuiper'
import { TwitterSingleFooter } from '../../../sharedDisplays/footers/TwitterSingleFooter'
import { TwitterSingleHeader } from '../../../sharedDisplays/headers/TwitterSingleHeader'
import { assetStyles } from '../../styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  content: string
  display: string
  isAccountPremium?: boolean
  isHovered: boolean
  isPresenting: boolean
  onContentChange: (val: string) => void
  onExpandAsset: (assetId: number) => void
  onRemoveAsset: (assetId: number) => void
  postType: string
  readOnly: boolean
  scheduledAt: string
  timezone: string
  video?: AssetReference
}

export const Single: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  content,
  display = 'mobileSingle',
  isAccountPremium,
  isHovered,
  isPresenting,
  onContentChange,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
  scheduledAt,
  timezone,
  video,
}) => {
  const [duration, setDuration] = useState(0)

  return (
    <Fragment>
      <TwitterSingleHeader
        accountImage={accountImage}
        accountName={accountName}
        accountUsername={accountUsername}
        content={content}
        isAccountPremium={isAccountPremium}
        isMobile={display.includes('mobile')}
        onContentChange={onContentChange}
        readOnly={readOnly}
      />
      <div
        css={assetStyles.getAssetContainerStyles(display)}
        className={kuiperClassNames('twitter-video-asset-container')}
      >
        {video && (
          <Asset
            autoPlay={duration !== 0 && duration <= 6}
            videoLoop={duration !== 0 && duration <= 6}
            isHovered={isHovered}
            getDuration={(duration: number) => setDuration(duration)}
            imageFit="cover"
            hasAssetOverlay={Boolean(video) && (!readOnly || isPresenting)}
            assetReference={video}
            hasAssetOptions={true}
            removeable={!isPresenting}
            onEmbiggen={() => onExpandAsset(video.id || 0)}
            onRemove={() => onRemoveAsset(video.id || 0)}
            overrideStyles={assetStyles.getAssetStyles(video, display)}
          />
        )}
      </div>
      <TwitterSingleFooter
        isMobile={display.includes('mobile')}
        scheduledAt={scheduledAt}
        timezone={timezone}
      />
    </Fragment>
  )
}
